import { FunctionComponent, useMemo } from 'react';
import ButtonLink from '../../../../../../ButtonLink';
import styles from './styles.module.scss';
import { FileLinesLightIcon } from '../../../../../../Icons';
import { useOrderCheckoutContext } from '../../../../../CheckoutContext/OrderContext';

export const DownloadInvoiceButton: FunctionComponent = () => {
    const { offers, checkoutState } = useOrderCheckoutContext();

    const costIsFree = useMemo(() => {
        const totalCostOfSelectedOffers = checkoutState.stepState.price.state?.offers.reduce(
            (acc, { offerId }) => {
                const offer = offers.find((offer) => offer._id === offerId);
                return acc + (offer?.price || 0);
            },
            0
        );

        return totalCostOfSelectedOffers === 0;
    }, [checkoutState.stepState.price.state?.offers, offers]);

    const downloadLinkText = useMemo(() => {
        const keyword =
            checkoutState.stepState.payment.state?.paymentMethod === 'invoice'
                ? 'Invoice'
                : 'Receipt';
        return `Download ${keyword}`;
    }, [checkoutState.stepState.payment.state?.paymentMethod]);

    if (costIsFree) return null;

    return (
        <ButtonLink
            href={`${process.env.NEXT_PUBLIC_CADEMY_API_URL}/order/${checkoutState.orderId}/invoice`}
            target="_blank"
            rel="noopener noreferrer"
            preset="default"
            className={styles.button}
        >
            <FileLinesLightIcon />
            {downloadLinkText}
        </ButtonLink>
    );
};
